<template lang="pug">
  v-container(fluid)
    v-layout(row wrap)
      v-flex(xs12)
        v-card
          v-card-title
            span.title Notificaciones Push
          v-card-text
            v-layout(row wrap)
              v-flex(xs12 md5)
                v-card(outlined)
                  v-card-title.subtitle-1 Enviar Notificación
                  v-card-text
                    v-text-field(v-model='titulo' label='Título *' outlined dense placeholder='Ej: Actualización de precios')
                    v-textarea(v-model='cuerpo' label='Mensaje *' outlined dense rows='3' placeholder='Escribe aquí el contenido de la notificación...')
                    v-radio-group(v-model='tipoDestinatario' row)
                      v-radio(label='Todos los vendedores' value='todos')
                      v-radio(label='Seleccionar vendedores' value='seleccion')
                    v-autocomplete(
                      v-if="tipoDestinatario === 'seleccion'"
                      v-model='seleccionados'
                      :items='vendedores'
                      item-text='ven_des'
                      item-value='co_ven'
                      label='Vendedores *'
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      deletable-chips
                    )
                    v-btn(color='primary' :loading='enviando' @click='enviar' block large)
                      v-icon(left) notifications
                      | Enviar Notificación Push

                    v-alert(v-if='resultado' :type='resultado.enviados > 0 ? "success" : "warning"' dense outlined style='margin-top:16px')
                      div
                        b {{ resultado.enviados > 0 ? "¡Envío completado!" : "Aviso de envío:" }}
                      div Enviadas a {{ resultado.enviados }} de {{ resultado.tokens }} dispositivo(s).
                      div(v-if='resultado.fallidos > 0' style='font-size:12px; margin-top:4px; color:#d32f2f')
                        | Tokens no entregados o inactivos: {{ resultado.fallidos }}

              v-flex(xs12 md7 style='padding-left:16px')
                v-card(outlined)
                  v-card-title.subtitle-1
                    | Vendedores con token FCM
                    v-spacer
                    v-text-field(
                      v-model='buscarVendedor'
                      append-icon='search'
                      label='Buscar vendedor...'
                      single-line
                      hide-details
                      dense
                      outlined
                      style='max-width:250px; margin-right:8px'
                    )
                    v-btn(icon small @click='cargarVendedores' :loading='cargando')
                      v-icon refresh
                  v-data-table(
                    :headers='headers'
                    :items='vendedoresFiltrados'
                    :loading='cargando'
                    hide-actions
                  )
                    template(slot='items' slot-scope='props')
                      td {{ props.item.co_ven.trim() }}
                      td {{ props.item.ven_des }}
                      td
                        v-chip(v-if='props.item.fcm_tokens && props.item.fcm_tokens.length > 0' small color='green' text-color='white')
                          | {{ props.item.fcm_tokens.length }} dispositivo{{ props.item.fcm_tokens.length > 1 ? "s" : "" }}
                        v-chip(v-else small color='grey' text-color='white') Sin dispositivo
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "Notificaciones",
  data: () => ({
    titulo: "",
    cuerpo: "",
    tipoDestinatario: "todos",
    seleccionados: [],
    vendedores: [],
    buscarVendedor: "",
    cargando: false,
    enviando: false,
    resultado: null,
    headers: [
      { text: "Código", value: "co_ven", width: "100px" },
      { text: "Nombre", value: "ven_des" },
      { text: "Tokens FCM", value: "fcm_tokens", width: "150px" },
    ],
  }),
  computed: {
    vendedoresFiltrados() {
      if (!this.buscarVendedor) return this.vendedores;
      const q = this.buscarVendedor.toLowerCase().trim();
      return this.vendedores.filter(
        (v) =>
          (v.co_ven && v.co_ven.toLowerCase().includes(q)) ||
          (v.ven_des && v.ven_des.toLowerCase().includes(q))
      );
    },
  },
  mounted() {
    this.cargarVendedores();
  },
  methods: {
    async cargarVendedores() {
      this.cargando = true;
      try {
        const res = await Api.get("vendedor/fcm-tokens");
        this.vendedores = res.data || [];
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo cargar la lista de vendedores con tokens FCM.",
        });
      } finally {
        this.cargando = false;
      }
    },
    async enviar() {
      if (!this.titulo || !this.titulo.trim()) {
        this.$swal.fire({
          icon: "warning",
          title: "Título requerido",
          text: "Por favor escribe un título para la notificación.",
        });
        return;
      }
      if (!this.cuerpo || !this.cuerpo.trim()) {
        this.$swal.fire({
          icon: "warning",
          title: "Mensaje requerido",
          text: "Por favor escribe el mensaje que deseas enviar.",
        });
        return;
      }
      if (
        this.tipoDestinatario === "seleccion" &&
        (!this.seleccionados || this.seleccionados.length === 0)
      ) {
        this.$swal.fire({
          icon: "warning",
          title: "Selecciona destinatarios",
          text: "Debes seleccionar al menos un vendedor de la lista.",
        });
        return;
      }

      this.enviando = true;
      this.resultado = null;
      try {
        const destinatarios =
          this.tipoDestinatario === "todos" ? "todos" : this.seleccionados;
        const res = await Api.post("vendedor/send-notification", {
          titulo: this.titulo.trim(),
          cuerpo: this.cuerpo.trim(),
          destinatarios,
        });

        this.resultado = res.data;

        if (this.resultado.tokens === 0) {
          this.$swal.fire({
            icon: "info",
            title: "Sin dispositivos registrados",
            text: "Ninguno de los vendedores seleccionados tiene token FCM registrado en sus dispositivos. La notificación fue guardada en el buzón de la app.",
          });
        } else if (this.resultado.enviados > 0) {
          this.$swal.fire({
            icon: "success",
            title: "¡Notificación enviada con éxito!",
            html: `Se entregó la notificación push a <b>${
              this.resultado.enviados
            }</b> dispositivo(s).<br><small style="color:#757575">Total de tokens procesados: ${
              this.resultado.tokens
            }${
              this.resultado.fallidos > 0
                ? ` (inactivos: ${this.resultado.fallidos})`
                : ""
            }</small>`,
          });
          // Limpiar formulario tras éxito
          this.titulo = "";
          this.cuerpo = "";
          if (this.tipoDestinatario === "seleccion") {
            this.seleccionados = [];
          }
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "No se pudo entregar",
            text: `Se intentó enviar a ${this.resultado.tokens} tokens pero todos fueron rechazados por el servidor de notificaciones (posibles tokens expirados o apps desinstaladas).`,
          });
        }
      } catch (e) {
        const errorMsg =
          e.response && e.response.data && e.response.data.msg
            ? e.response.data.msg
            : e.message ||
              "Ocurrió un error inesperado al enviar las notificaciones.";
        this.$swal.fire({
          icon: "error",
          title: "Error al enviar",
          text: errorMsg,
        });
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>
